import React from 'react';
import Button from '../../ui/Button';

interface WidgetErrorStateProps {
  /** Main error message */
  message: string;
  /** Optional secondary detail text */
  details?: string;
  /** If provided, a retry button is shown */
  onRetry?: () => void;
  /** Label for the retry button */
  retryLabel?: string;
  /** Custom icon to display instead of the default warning triangle */
  icon?: React.ReactNode;
  className?: string;
}

const DefaultIcon = () => (
  <svg className="w-6 h-6 text-danger-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
    />
  </svg>
);

const WidgetErrorState: React.FC<WidgetErrorStateProps> = ({
  message,
  details,
  onRetry,
  retryLabel = 'Retry',
  icon,
  className = '',
}) => (
  <div className={`h-full flex items-center justify-center p-6 ${className}`}>
    <div className="text-center max-w-xs">
      <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-danger-100 flex items-center justify-center">
        {icon || <DefaultIcon />}
      </div>
      <p className="font-semibold text-danger-700 text-sm">{message}</p>
      {details && <p className="text-xs text-danger-600 mt-1">{details}</p>}
      {onRetry && (
        <Button variant="danger" size="sm" onClick={onRetry} className="mt-4">
          {retryLabel}
        </Button>
      )}
    </div>
  </div>
);

export default WidgetErrorState;
